import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { combineLatest, map } from 'rxjs';
import { AppComponent } from 'src/app/app.component';
import { CheckoutIntegrationStatus } from 'src/app/models/CheckoutIntegrationStatus';
import { OrderStatus } from 'src/app/models/OrderStatus';
import { Venue } from 'src/app/models/Venue';
import { AppSettingsService } from 'src/app/services/app-settings.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { ManagerFacade } from 'src/app/store/manager/+state/manager.facade';
import { filterOrders } from 'src/app/utils/utils';

@Component({
	selector: 'app-manager-header',
	templateUrl: './manager-header.component.html',
	styleUrls: ['./manager-header.component.scss'],
})
export class ManagerHeaderComponent implements OnInit {
	@Input() venue: Venue | null;
	@Input() showBack = false;
	@Input() showChip = false;
	@Input() showFaq = false;
	@Input() showHelp = false;
	@Input() showNotification = false;
	@Input() showMessages = false;
	@Input() listenShowBack = false;
	@Output() backEvent = new EventEmitter<void>();

	showHelpAllowed = !AppComponent.isFranceDomain;

	OrderStatus = OrderStatus;
	filtersChips = [
		{
			status: OrderStatus.FAILED,
			quantity: 0,
			color: '#B0063E',
			selected: false,
		},
		{ status: null, quantity: 0, color: '#B0063E', selected: false },
		{
			status: OrderStatus.IN_PREPARATION,
			quantity: 0,
			color: '#FD5E00',
			selected: false,
		},
		{ status: OrderStatus.READY, quantity: 0, color: '#34A853', selected: false },
		{ status: OrderStatus.DONE, quantity: 0, color: '#A9A9A9', selected: false },
	];
	filteredOrders$ = combineLatest([this.managerFacade.orders$, this.appSettingsService.appSettings$]).pipe(
		map(([orders, settings]) => filterOrders(orders, settings))
	);
	filtersChips$ = combineLatest([this.filteredOrders$, this.managerFacade.orderStatusFiler$]).pipe(
		map(([orders, status]) => {
			const statusCount = orders.reduce(
				(acc, obj) => {
					if (
						obj.checkoutIntegrationStatus === CheckoutIntegrationStatus.REJECTED ||
						obj.checkoutIntegrationStatus === CheckoutIntegrationStatus.CANCELED ||
						obj.status === OrderStatus.FAILED
					) {
						acc[OrderStatus.FAILED] = (acc[OrderStatus.FAILED] || 0) + 1;
						return acc;
					}

					if (obj.status) {
						acc[obj.status] = (acc[obj.status] || 0) + 1;
					}

					return acc;
				},
				{} as Record<string, number>
			);

			return this.filtersChips.map(chip => {
				const selected = status === chip.status;

				let quantity = 0;

				if (!chip.status) {
					quantity = orders.filter(it => it.status !== OrderStatus.DONE && it.status !== OrderStatus.FAILED).length;
				} else {
					quantity = statusCount[chip.status] ?? 0;
				}

				return {
					...chip,
					selected,
					quantity,
				};
			});
		})
	);
	constructor(
		private managerFacade: ManagerFacade,
		private navService: NavigationService,
		private appSettingsService: AppSettingsService
	) {}

	ngOnInit() {}

	async onBurgerClick() {
		await this.navService.adminConsole();
		// await this.navService.pinCode();
	}

	async navigateBack() {
		if (this.listenShowBack) {
			this.backEvent.emit();
			return;
		}
		this.navService.managerPage();
	}

	getColor(status: string) {
		let defaultColor = '#B0063E';
		switch (status) {
			case OrderStatus.DONE:
				defaultColor = '#A9A9A9';
				break;
			case OrderStatus.READY:
				defaultColor = '#34A853';
				break;
			case OrderStatus.IN_PREPARATION:
				defaultColor = '#FD5E00';
				break;
			default:
				break;
		}
		return defaultColor;
	}
	selectItem(status: OrderStatus | null) {
		this.managerFacade.setFilterOrderStatus(status);
	}
	back() {
		this.navService.managerPage();
	}
	openFaq() {
		AppComponent.isFranceDomain
			? window.open('../../../../assets/pdfs/faq_fr.pdf', '_blank')
			: window.open('../../../../assets/pdfs/faq_de.pdf', '_blank');
	}
	openHelp() {
		window.open('../../../../assets/pdfs/help.pdf', '_blank');
	}
}
